export const findMarketById = (marketId, markets) =>
	markets.find((market) => market._id === marketId);
